import React, { memo } from 'react';

import { createWholeWorldViewMaskPolygon } from '../../../utils/helpers/utils';
import SourceLayers from '../../source-layers/SourceLayers';

const maskId = 'MASK_EDIT_LOCATION_CIRCLE';

export interface MaskLayerProps {
  polygon;
}

const MaskLayerInternal = ({ polygon }: MaskLayerProps) => (
  <SourceLayers
    source={{
      id: maskId,
      data: {
        type: 'geojson',
        data: createWholeWorldViewMaskPolygon(
          polygon,
        ) as unknown as GeoJSON.Geometry,
      },
    }}
    layers={{
      id: maskId,
      source: maskId,
      type: 'fill',
      paint: {
        'fill-color': 'white',
        'fill-opacity': 0.5,
      },
    }}
  />
);

MaskLayerInternal.displayName = 'MaskLayer';

// don't rerender it if not needed
export const MaskLayer = memo(MaskLayerInternal);
